<template>
  <div>
    <ServiceRequestCreate ref="serviceRequestCreate" :policy="policy" :serviceRequestType="serviceRequestKey" :initialID="ID" @onDataRetrived="onDataRetrived">
      <div slot="serviceRequestType" slot-scope="row">
        <FITAutoSearch v-model="agent" :label="getLabel('currentAgent')" dest="option" :disabled="row.isLocked" :paras="[{ key: 'type', value: 'agent' }]" :showItems="['englishFullname', 'chineseFullname']" :width="columnWidth"></FITAutoSearch>
      </div>
    </ServiceRequestCreate>
  </div>
</template>
<script type="text/javascript">
import ServiceRequestCreate from '../ServiceRequestCreate'

import {
  FITTextInput,
  FITButton,
  FITAutoSearch,
  FITSelect,
  FITTextarea,
  FITDatePicker
} from '@/components'

import { mapGetters, mapState } from 'vuex'
import Vue from 'vue'
export default {
  name: 'GIAssignment',
  components: {
    ServiceRequestCreate,
    FITTextInput,
    FITButton,
    FITAutoSearch,
    FITSelect,
    FITDatePicker,
    FITTextarea
  },

  methods: {
    getLabel(field) {
      return this.$t(`osm.serviceRequest.type.${this.serviceRequestKey}.${field}`);
    },

    onDataRetrived(data) {
      this.selectedType.list
        .forEach((column) => {
          Vue.set(this.form, column.fieldColumn, this.selectedType.data[column.fieldColumn])
        })

      this.$store.dispatch('searchOption', {
          optionType: 'agent',
          searchInput: {
            ID: this.selectedType.data['currentAgent'],
          },
          dest: 'option'
        })
        .then((json) => {
          if (json.length > 0) {
            let agent = json[0];
            Vue.set(this, 'agent', {
              ID: agent['ID'],
              englishFullname: agent['englishFullname'],
              chineseFullname: agent['chineseFullname']
            })
          }
        })
    }
  },

  data() {
    return {
      type: {},

      agent: {
        ID: -1,
        englishFullname: '',
        chineseFullname: ''
      },

      form: {
        ID: this.policy.policyID,
        currentAgent: null
      },

      serviceRequestKey: 'GAS'
    }
  },

  props: {
    ID: {
      type: Number,
      default: null
    },

    policy: {
      type: Object,
      required: true
    }
  },

  computed: {
    columnWidth() {
      if (this.$refs.serviceRequestCreate) {
        return this.$refs.serviceRequestCreate.option.data.column;
      }
      return 10;
    },

    ...mapGetters('ServiceRequest', [
      'getTranslated',
      'getTranslatedArray',
      'getTranslatedString',
      'isValueModified',
      'getServiceRequestTranslated'
    ]),

    ...mapState('ServiceRequest', [
      'fields',
      'selectedType'
    ]),
  },

  created() {
    if (!this.policy) {
      console.debug(this.serviceRequestKey, 'Null policy ID when routing to service request');
      return
    }
  },

  watch: {
    agent: {
      deep: true,
      handler(val) {
        Vue.set(this.form, 'currentAgent', val.ID);
      }
    },

    form: {
      deep: true,
      handler(val) {
        this.$store.commit({
          type: 'ServiceRequest/setTypeForm',
          form: JSON.parse(JSON.stringify(val))
        })
      }
    }
  }

}

</script>



// WEBPACK FOOTER //
// src/Osm/ServiceRequest/components/ServiceRequestTypes/GIAssignment.vue